import React from 'react'
import { Button } from '@chilipiper/design-system/src/new'
import { Link } from '@chilipiper/navigation'
import { useCalendarIntegration } from '@chilipiper/integrations'
import { useFireSessionContext } from '@chilipiper/fire-session'
import { Box, Flex, Icon, Text } from '@chilipiper/design-system'
import { SvgWarningTriangle } from '@chilipiper/icons'
import { routes } from '../routes/routes'

export const NotConnectedCalendarBanner = () => {
  const { userId } = useFireSessionContext()
  const { data: calendarIntegration } = useCalendarIntegration(userId)
  const userCalendarIntegration = calendarIntegration?.connectionStatuses[userId]

  const isCalendarIntegrationNotConnected =
    userCalendarIntegration?.primary?.type === 'Success' &&
    ['DisconnectedAccount', 'NeverConnectedAccount'].includes(
      userCalendarIntegration.primary.value?.type
    )

  if (!isCalendarIntegrationNotConnected) {
    return null
  }

  return (
    <Box bg='bg/section'>
      <Flex alignItems='center' gap={6} py={3} pl={6} pr={4} bg='bg/warning' boxShadow='border/row'>
        <Flex gap={4} alignItems='center' flexGrow={1}>
          <Flex borderRadius={12} p={2} bg='bg/section'>
            <Icon icon={SvgWarningTriangle} color='fg/warning' w={4} h={4} />
          </Flex>
          <Flex gap={1}>
            <Text textStyle='heading-m' color='fg/major'>
              To schedule meetings or have meetings routed to you, you
            </Text>
            <Text textStyle='heading-m' color='fg/major' fontWeight={700}>
              must
            </Text>
            <Text textStyle='heading-m' color='fg/major'>
              connect your calendar.
            </Text>
          </Flex>
        </Flex>
        <Link to={routes.integrations}>
          {linkProps => (
            <Button as='a' variant='major' {...linkProps}>
              Go to Integrations
            </Button>
          )}
        </Link>
      </Flex>
    </Box>
  )
}
